import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmbedLoginService, JwtService, UtilsService } from '@core/services';
import { AuthService } from '../auth.service';
import { APPS } from '@core/assets/constants';

/**
 * Allows choosing, from the received token, the Mars group/licence to log in
 * as, when a single token grants access to several groups.
 */
@Component({
  selector: 'app-mars-group-selector',
  templateUrl: './mars-group-selector.component.html',
  styleUrls: ['./mars-group-selector.component.scss']
})
export class MarsGroupSelectorComponent implements OnInit {
  public groups: Array<any> = [];
  public error: any = null;
  private token: string = null;
  public marsSid: string = APPS.mars;

  constructor(
    public utilsService: UtilsService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private embedLoginService: EmbedLoginService,
    private jwtService: JwtService
  ) {}

  /**
   * Extracts the available groups to select from the route's token.
   */
  ngOnInit(): void {
    this.token = this.route.snapshot.queryParams.token;
    const data = this.jwtService.getTokenData(this.token);
    this.groups = data.groups;
  }

  /**
   * Authenticates the user with the selected licence/group.
   * @param licenseId Identifier of the chosen licence/group
   */
  handleSelectMatch(licenseId: string): void {
    this.authService
      .createServiceLogin({
        token: this.token,
        sid: APPS.mars,
        licenseId
      })
      .subscribe({
        next: (response) => {
          this.embedLoginService.onLoginSuccess(response);
        },
        error: (error) => {
          console.error(error);
          this.error = error;
        }
      });
  }
}
